import { IconComponentFunction, PaperStackIcon, SpeedometerIcon, VehicleBootIcon, VehicleDashboardIcon, VehicleDriverSideIcon, VehicleInteriorIcon, VehiclePassengerSideIcon, VehicleTyreTreadIcon, VehicleWheelIcon } from '@motorway/mw-highway-code';

export const resolveVehiclePhotoBlockIcon = (kind?: string): IconComponentFunction | null => {
  switch (kind) {
  case 'exterior_front_driver':
  case 'exterior_rear_driver':
    return VehicleDriverSideIcon;
  case 'exterior_front_passenger':
  case 'exterior_rear_passenger':
    return VehiclePassengerSideIcon;
  case 'interior_front_seats':
  case 'interior_rear_seats':
    return VehicleInteriorIcon;
  case 'interior_dashboard':
    return VehicleDashboardIcon;
  case 'instrument_cluster':
    return SpeedometerIcon;
  case 'interior_boot':
    return VehicleBootIcon;
  case 'docs_service_history':
    return PaperStackIcon;
  case 'tyre_tread_front_driver':
  case 'tyre_tread_front_passenger':
  case 'tyre_tread_rear_driver':
  case 'tyre_tread_rear_passenger':
    return VehicleTyreTreadIcon;
  case 'wheels_front_driver':
  case 'wheels_front_passenger':
  case 'wheels_rear_driver':
  case 'wheels_rear_passenger':
    return VehicleWheelIcon;
  default:
    return null;
  }
};
